import { render, staticRenderFns } from "./HistorySidebarV2.vue?vue&type=template&id=7edabc8b&scoped=true"
import script from "./HistorySidebarV2.vue?vue&type=script&lang=js"
export * from "./HistorySidebarV2.vue?vue&type=script&lang=js"
import style0 from "./HistorySidebarV2.vue?vue&type=style&index=0&id=7edabc8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edabc8b",
  null
  
)

export default component.exports